export default __webpack_public_path__ + "static/Hardest-Marathons-in-the-World-Hero-Image-20a19189b9062862b6cd1666cadc52cc.jpg";